// utils/ApolloProvider.js
import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { ApolloProvider } from "@apollo/client/react";
import { setContext } from "@apollo/client/link/context";
import { ApiService } from '../service/ApiService';

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL_URL });
const authLink = setContext((_, { headers }) => ({
    headers: {
        ...headers,
        ...ApiService.setHeader(true),
    },
}));

const client = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
});

export const ApolloClientProvider = ({ children }) => (
    <ApolloProvider client={client}>
        {children}
    </ApolloProvider>
);